import {Injectable} from "@angular/core";

export enum CanvasType {
  DOOR = 'door',
  SCENARIO = 'scenario',
  DOWNLOAD = 'download'
}

@Injectable({providedIn: 'root'})
export class CanvasCache {

  private cache: Map<CanvasType, HTMLCanvasElement>

  constructor() {
    this.cache = new Map<CanvasType, HTMLCanvasElement>();
  }

  public get(type: CanvasType, {width, height}: { width: number, height: number }): {
    canvas: HTMLCanvasElement,
    context: CanvasRenderingContext2D
  } {
    let canvas = this.cache.get(type);
    if (!canvas) {
      canvas = document.createElement('canvas');
      this.cache.set(type, canvas);
    }

    const context = canvas.getContext('2d');
    if (!context) {
      throw new Error('Could not get context of temporary canvas')
    }

    context.clearRect(0, 0, canvas.width, canvas.height);

    canvas.width = width;
    canvas.height = height;

    return {
      canvas,
      context
    };
  }

  public clear() {
    // Remove all canvases
    for (const [type, canvas] of this.cache) {
      canvas.remove();
    }

    this.cache.clear();
  }
}
